import { render } from "./ConfirmDialogue.vue?vue&type=template&id=0f05d9aa"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__